import { render, staticRenderFns } from "./TaskActHistoricDetailBtn.vue?vue&type=template&id=38f8c784"
import script from "./TaskActHistoricDetailBtn.vue?vue&type=script&lang=js"
export * from "./TaskActHistoricDetailBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports